<template>
	<section class="find-out-more">
		<div class="eia-page-boundary-container">
			<div class="find-out-more__container">
				<div>
					<eia-heading level="h4">Find out more about...</eia-heading>
					<eia-caption>
						Praeterea, ex culpa non invenies unum auf non accusatis unum. Et nihil inuitam. Nemo nocere tibi erit, et non inimicos, et ne illa laederentur.
					</eia-caption>

					<eia-link>View more information</eia-link>
				</div>

				<router-link class="faq"
					:to="{ name: 'FAQs' }">
					<font-awesome-icon icon="chalkboard-teacher"></font-awesome-icon>
					<span>Read our frequently asked questions</span>
				</router-link>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'eia-find-out-more',
};
</script>

<style lang="scss" scoped>
.find-out-more {

	&__container {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 0 128px;
		border-top: 1px solid $color-grey-medium;
		// margin-top: 32px;
		padding-top: 24px;
		padding-bottom: 24px;

		@media screen and (max-width: $screen-s) {
			grid-template-columns: 1fr;
			grid-gap: 48px 0;
		}
	}

	.faq {
		display: flex;
		align-items: center;
		justify-content: flex-start;

		svg {
			margin-right: 8px;
			font-size: $text-h1;
		}

		.eia-heading {
			margin: 0;
		}
	}
}
</style>
